import React from "react";
import {connect} from "react-redux";
import moment from 'moment'
import withStyles from "@material-ui/core/styles/withStyles";
import InputAdornment from "@material-ui/core/InputAdornment";
import TextField from "@material-ui/core/TextField";
// core components
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
//import MenuItem from "@material-ui/core/MenuItem";
import Button from "components/CustomButtons/Button.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import PictureUpload from "components/CustomUpload/PictureUpload.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import Face from "@material-ui/icons/Face";
import countryList from 'country-list'
import Email from "@material-ui/icons/Email";
import RecordVoiceOver from "@material-ui/icons/RecordVoiceOver";
import AssignmentInd from "@material-ui/icons/AssignmentInd";
import Phone from "@material-ui/icons/Phone";
import LocationOn from "@material-ui/icons/LocationOn";
import Business from "@material-ui/icons/Business";
import LocalLibrary from "@material-ui/icons/LocalLibrary";
import StoreMallDirectory from "@material-ui/icons/StoreMallDirectory";
import Share from "@material-ui/icons/Share";

import styles from "assets/jss/material-dashboard-pro-react/views/form";

import {
  ibSave,
  //ibsFetch,
  ibFetch
} from 'actions/ibs'

import {
  danger,
} from 'actions/notification'

class GeneralInfo extends React.Component {
	state = {
		form: {
			firstName: '',
      lastName: '',
      middleName: '',
      birthDate: '',
      nationality: '',
      email: '',
      phoneNumber: '',
      street: '',
      houseFlatNumber: '',
      city: '',
      postCode: '',
      webSite: ''/*,
      externalId: ''*/
    },
    loadingButton: false
  }
  componentDidMount(){
      if(this.props.match.params.id) {
          this.props.saveWizardData(this.props.stepDataObject.data)
          this.setFormFields(this.props.stepDataObject.data)
      }
  }

  setFormFields(e){
    this.setState({
      ...this.state,
      form:{
        firstName: e.firstName,
        lastName: e.lastName,
        middleName: e.middleName,
        birthDate: e.birthDate,
        nationality: e.nationality,
        email: e.email,
        phoneNumber: e.phoneNumber,
        street: e.street,
        houseFlatNumber: e.houseFlatNumber,
        city: e.city,
        postCode: e.postCode,
        webSite: e.webSite/*,
        externalId: e.externalId*/
      }
    })
  }
	change(event,name){
    this.setState({
      ...this.state,
      form:{
        ...this.state.form,
        [name]:event.target.value
      },
    })
	}
	getInput(data){
    return   <CustomInput
        labelText={
          <span>
            {data.name} {(data.required?<small>*</small>: <small>(optional)</small>)}
          </span>
        }
        id={data.key}
        formControlProps={{
          fullWidth: true
        }}
        inputProps={{
          onChange: event => this.change(event, data.key),
          required:data.required,
          value:this.state.form[data.key] || '',
          type:data.type,
          disabled: data.disabled ? data.disabled : false,
          endAdornment: (
            <InputAdornment
              position="end"
              className={this.props.classes.inputAdornment}
            >
              {data.icon}
            </InputAdornment>
          )
        }}
    />
  }
  fetchDataOnCreate(data){
    this.props.fetch(data.ibId).then((e)=> {
      //console.log('externalid', e.externalId)
      /*if(e.externalId){
        this.props.saveWizardData(e)
        this.setFormFields(e)
      }*/
    })
  }
	submit(e){
    e.preventDefault()
    const history = this.props.history
    const match = this.props.match
    const editmode = match.params.id
    let data = {...this.props.wizardData, ...this.state.form}
    if(editmode){
      this.props.save(data)
      .then(e => {
        this.props.saveWizardData(e)
        this.props.goToNextStep({data: e})
      })
      .catch(e=>{this.props.danger(e+'',4);})
    } else { //create mode
      this.setState({...this.state, loadingButton: true})
      this.props.save(data)
        .then(e => {
          this.props.saveWizardData(e)
          //get data every 1 sec for 30 seconds
          let timerId = setInterval(() => this.fetchDataOnCreate(e), 1000)
          // after 30 seconds stop
          setTimeout(() => {
            clearInterval(timerId)
            history.push(`/administration/ibs/${e.ibId}`);
            window.location.reload();
           // this.props.goToNextStep()
            this.setState({...this.state, loadingButton: false})
          }, 1000)

        })
        .catch(e=>{this.props.danger(e+'',4);})
    }
	}
  render() {
    const {classes} = this.props
    const match = this.props.match
    const editmode = match.params.id
    const birthDate = this.state.form.birthDate
      ? moment(this.state.form.birthDate).format('YYYY-MM-DD')
      : ''
    
    const countries = countryList.getData()
  	return (
			<form onSubmit={(e) => this.submit(e)}>
				<GridContainer justify="center">
				<GridItem xs={12} sm={3} md={3}>
					<PictureUpload />
				</GridItem>
				<GridItem xs={12} sm={8} md={8}>
					{this.getInput({
            key:'firstName',
            name:'First Name',
            icon:<Face className={this.props.classes.inputAdornmentIcon}/>,
            type:'text',
            required:true
					})}
					
					{this.getInput({
            key:'lastName',
            name:'Last Name',
            icon:<RecordVoiceOver className={this.props.classes.inputAdornmentIcon}/>,
            type:'text',
            required:true
          })}
          
          {this.getInput({
            key:'middleName',
            name:'Middle Name',
            icon:<AssignmentInd className={this.props.classes.inputAdornmentIcon}/>,
            type:'text',
            required:false
					})}
				</GridItem>
        <GridItem xs={12} sm={11} md={11}>

					<FormControl
						fullWidth
						style={{paddingTop:'10px', marginBottom: '17px'}}
					>
            <TextField
              id="birthDate"
              label="Date of Birth"
              type="date"
              onChange={(event) => this.change(event, "birthDate")}
              value={birthDate}
              required={true}
              //style={{color: '#D2D2D2 !important'}}
              //defaultValue={registrationDate}
              className={classes.textField}
              InputLabelProps={{
                shrink: true,
              }}
            />
		  		</FormControl>

          <FormControl
            fullWidth
            className={classes.selectFormControl}
            style={{marginTop:'10px', marginBottom: '17px'}}
          >

            <InputLabel
              htmlFor="nationality"
              className={classes.selectLabel}
            >
              Nationality*
            </InputLabel>

            <Select
              required={true}
              native
              value={this.state.form.nationality || '' }
              MenuProps={{ className: classes.selectMenu }}
              classes={{ select: classes.select }}            
              inputProps={{
                onChange: event => this.change(event, "nationality"),
                id: "nationality"
              }}
            >
              <option value="" disabled></option>
              {Object.values(countries).map(item => 
                <option key={item.code} value={item.name}>{item.name}</option>
              )}
            </Select>  
          </FormControl>
          
          {this.getInput({
            key:'email',
            name:'Email',
            icon:<Email className={this.props.classes.inputAdornmentIcon}/>,
            type:'text',
            required:true
          })}

          {this.getInput({
            key:'phoneNumber',
            name:'Phone',
            icon:<Phone className={this.props.classes.inputAdornmentIcon}/>,
            type:'text',
            required:true
          })}

        </GridItem>

        <GridItem xs={12} sm={11} md={11}>
          <h2 style={{fontSize: '16px', fontWeight: 'bold', paddingTop: '35px', paddingBottom: '10px'}}>Address</h2>
        </GridItem>

        <GridItem xs={12} sm={11} md={11}>
          {this.getInput({
            key:'street',
            name:'Street',
            icon:<LocationOn className={this.props.classes.inputAdornmentIcon}/>,
            type:'text',
            required:true
          })}

          {this.getInput({
            key:'houseFlatNumber',
            name:'House/Flat No.',
            icon:<Business className={this.props.classes.inputAdornmentIcon}/>,
            type:'text',
            required:false
          })}

          {this.getInput({
            key:'city',
            name:'City',
            icon:<StoreMallDirectory className={this.props.classes.inputAdornmentIcon}/>,
            type:'text',
            required:true
          })}

          {this.getInput({
            key:'postCode',
            name:'Post Code',
            icon:<LocalLibrary className={this.props.classes.inputAdornmentIcon}/>,
            type:'text',
            required:false
          })}

          {this.getInput({
            key:'webSite',
            name:'Website',
            icon:<Share className={this.props.classes.inputAdornmentIcon}/>,
            type:'text',
            required:false
          })}

          {/*this.getInput({
            key:'externalId',
            name:'External Id',
            icon:<SwitchCamera className={this.props.classes.inputAdornmentIcon}/>,
            type:'text',
            required:false,
            disabled: editmode ? false : true 
          })*/}

        </GridItem>

				<GridItem sm={11}>
					<div style={{float: 'right'}}>
						<Button
              disabled={this.state.loadingButton}
							color="success"
							type="submit"
							style={{position:'absolute', bottom:'10px', right:'40px'}}
						>
							{this.state.loadingButton && !editmode ? <span><i className="fas fa-spinner fa-spin"></i></span> : 'Next'}
						</Button>
					</div>
				</GridItem>
				</GridContainer>
			</form>
  	);
  }
}
const state=(state)=>({
  ibs: state
})
const dispatch=(dispatch)=>({
  fetch:(id)=>dispatch(ibFetch(id)),
  save:(data)=>dispatch(ibSave(data)),
  danger:(text,sec)=>dispatch(danger(text,sec)),
})
export default withStyles(styles)(connect(state,dispatch)(GeneralInfo))



// WEBPACK FOOTER //
// ./src/views/Ibs/Wizard/GeneralInfo.jsx